/**
 * 站内通知 API（对齐 NotificationController）。
 *
 * 真实端点（经网关 /api，StripPrefix=1）：
 * - GET  /notification/my            我的通知列表（按创建时间倒序）
 * - GET  /notification/unread-count  我的未读通知数（角标）
 * - PUT  /notification/{id}/read     标记单条已读
 * - PUT  /notification/read-all      全部标记已读
 *
 * 全部按当前登录用户过滤（recipient_id），org_id 由多租户拦截器隔离。
 */
import { request } from './request';

/** 通知条目（对齐 Notification 实体） */
export interface NotificationItem {
  id: string;
  recipientId?: string;
  channel?: string;
  category?: string;
  title?: string;
  content?: string;
  priority?: string;
  read?: boolean;
  readAt?: string;
  refType?: string;
  refId?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

/** 我的通知列表（onlyUnread / category / limit 可空） */
export function getMyNotifications(params?: {
  onlyUnread?: boolean;
  category?: string;
  limit?: number;
}): Promise<NotificationItem[]> {
  return request<NotificationItem[]>('/notification/my', { params });
}

/** 我的未读通知数（Tab 角标） */
export function getUnreadCount(category?: string): Promise<number> {
  return request<number>('/notification/unread-count', { params: category ? { category } : undefined });
}

/** 标记单条已读 */
export function markNotificationRead(id: string): Promise<boolean> {
  return request<boolean>(`/notification/${id}/read`, { method: 'PUT' });
}

/** 全部标记已读 */
export function markAllNotificationsRead(category?: string): Promise<number> {
  return request<number>('/notification/read-all', {
    method: 'PUT',
    params: category ? { category } : undefined,
  });
}
